export default __webpack_public_path__ + "static/media/bg51.c7ab6ef6.png";